import { Form } from 'antd';
import { CustomSelect } from '../../../../../uiComponents/CustomSelect';
import { messages, placeHolders } from '../../../../../../constants';

export const PromotionSelect = ({ promos, setPromotionId }) => {
  return (
    <Form.Item
      label="Promociones"
      name="promoId"
      rules={[{ required: true, message: messages.required('Promociones') }]}
    >
      <CustomSelect
        allowClear
        placeholder={placeHolders.promo}
        onChange={setPromotionId}
        options={promos?.map(({ id, name }) => ({
          value: id,
          label: name,
        }))}
      />
    </Form.Item>
  );
};